import type { z } from "zod";

import { zOutSchema } from "./common";

import { Request, Response } from "~/shared/api";

const zRes = Response.Schema.zSuccessful(200, Request.Pagination.Page.zSchema(zOutSchema));
type Res = z.infer<typeof zRes>;

export { zRes };
export type { Res };
